
import { downloadCSVFiles, getDateWithTimeString } from '@/helpers/shadcn/utils'
import { useDataTable } from '@/hooks/useDataTable-hook'
import { GetFormattedActivityData } from '@/models/ActivityListModel'
import { getActivityCsvFile, handleGetActivity } from '@/services/activities'
import { ActivitiesColConfig } from '@/services/MockData/Activity/ActivitiesColConfig'
import { useQueries } from '@tanstack/react-query'
import { useMemo } from 'react'

export const useActivites = () => {

  const { setPageIndex, setSortingObj, setSearchArry, pageIndex, sortingObj } = useDataTable()

  const queryParams = useMemo(() => {
    const params = new URLSearchParams()
    if (sortingObj?.column) {
      params.append('sortBy', sortingObj?.column)
      params.append('order', sortingObj?.direction)
    }
    if (pageIndex) {
      params.append('page', pageIndex)
    }
    return params.toString()
  }, [sortingObj?.column, sortingObj?.direction, pageIndex])

  const [activitiesResults] = useQueries({
    queries: [
      {
        queryKey: ['GET_ACTIVITY', queryParams],
        queryFn: () => handleGetActivity(queryParams)
      },
    ],
  })
  const onDownloadBtnClick = async selectedIds => {
    const data = await getActivityCsvFile(
      `ids=${selectedIds}${Object.keys(queryParams).length > 0 ? `&${queryParams}` : ''}`
    )
    const fileName = `Activity_${getDateWithTimeString()}`
    downloadCSVFiles(data, fileName)
  }
  const resultsData = useMemo(() => activitiesResults?.data || {}, [activitiesResults?.data])
  const activityListData = useMemo(() => GetFormattedActivityData(resultsData), [resultsData])

  return {
    activityListData,
    activityLColConfigData: ActivitiesColConfig,
    setPageIndex,
    setSortingObj,
    setSearchArry,
    onDownloadBtnClick,
  }
}
